import { type ButtonHTMLAttributes, type Ref } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  /**
   * Estado de carregamento. Desabilita o botao junto, e nao apenas mostra o
   * giro: botao que gira mas aceita clique produz a segunda requisicao, e em
   * operacao nao idempotente isso vira registro duplicado.
   */
  readonly loading?: boolean;
  readonly ref?: Ref<HTMLButtonElement>;
}

export function Button({
  variant = 'secondary',
  loading = false,
  disabled = false,
  type = 'button',
  className,
  children,
  ...rest
}: ButtonProps) {
  const { t } = useTranslation();
  const classes = [styles.button, styles[variant], className].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading ? true : undefined}
      {...rest}
    >
      {loading ? <span className={styles.spinner} aria-hidden="true" /> : null}
      <span>{children}</span>
      {loading ? <span className="visually-hidden">{t('button.loading')}</span> : null}
    </button>
  );
}
